$(document).ready(function () {
    let brandDropdown = $("#currentbrand");
    let productDropdown = $("#currentproduct");
    let shadeDropdown = $("#currentshade");
    let quizBtn=$(".current_foundation_btn_section #current-f-shade");
    const serverUrl="https://nodeapi.luarbeauty.in";      
    // Load brands on page load or button click
    $('#quiz-1').click(function() {
        $.ajax({
            url: "https://getskinmatch.com/_ajax/foundationfinder-brand-autocomplete.php",
            method: "GET",
            dataType: "json",
            success: function (response) {
                brandDropdown.empty().append('<option value="">Select Brand</option>');

                if (response.items && Array.isArray(response.items)) {
                    $.each(response.items, function (index, brand) {
                        brandDropdown.append('<option value="' + brand.brand_id + '">' + brand.brand_name + '</option>');
                    });
                } else {
                    alert("Invalid brand data received.");
                }
            },
            error: function () {
                alert("Failed to fetch brands.");
            }
        });
    });

    // Load products based on selected brand
    brandDropdown.change(function () {
        let brandId = $(this).val();
        productDropdown.empty().append('<option value="">Select Product</option>');
        shadeDropdown.empty().append('<option value="">Select Shade</option>'); // Reset shades

        if (brandId) {
            $.ajax({
                url: "https://getskinmatch.com/_ajax/foundationfinder-product-autocomplete.php",
                method: "GET",
                data: { brand_id: brandId },
                dataType: "json",
                success: function (response) {
                    if (response.items && Array.isArray(response.items)) {
                        $.each(response.items, function (index, product) {
                            productDropdown.append('<option value="' + product.ID + '">' + product.title + '</option>');
                        });
                    } else {
                        alert("Invalid product data received.");
                    }
                },
                error: function () {
                    alert("Failed to fetch products.");
                }
            });
        }
    });

    // Load shades based on selected product
    productDropdown.change(function () {
        let productId = $(this).val();
        shadeDropdown.empty().append('<option value="">Select Shade</option>');
    
        if (productId) {
            $.ajax({
                url: "https://getskinmatch.com/q/ajax/get-product-shades.php",
                method: "GET",
                data: { product_id: productId },
                dataType: "json",
                success: function (response) {
    
                    if (response.shades && Object.keys(response.shades).length > 0) {
                        $.each(response.shades, function (key, shade) {
                            shadeDropdown.append('<option style="background-color:'+shade.skintone_hex+'" value="' + shade.skintone_primarycolor + '">' + shade.subtitle + '</option>');
                        });
                    } else {
                        console.error("Shades data is missing or empty:", response);
                        alert("No shades available for this product.");
                    }
                },
                error: function (xhr, status, error) {
                    alert("Failed to fetch shades.");
                }
            });
        } 
    });
  quizBtn.on("click", function (e) {
      e.preventDefault(); // Prevents default behavior (useful if inside a form)
  
      // Fetch values from input fields
      let brandValue = $("#currentbrand").val();
      let productValue = $("#currentproduct").val();
      let shadeValue = $("#currentshade").val();
  
      // Validate if values are present
      if (!brandValue || !productValue || !shadeValue) {
          console.error("Error: One or more required values are missing.");
          alert("Please select a brand, product, and shade before proceeding.");
          return; // Stop execution if any value is missing
      }
    let resultData={
      "currentbrand":brandValue,
      "currentproduct":productValue,
      "currentshade":shadeValue,
      "method_call":"getQuizResult"
    }

      $.ajax({
              url: `${serverUrl}/getQuizResult?customerId=${cust_id}`,
              method: "POST",
              data:resultData,
              dataType: "json",
              success: function (response) {
                let responseData=response;
                
                  if(responseData.additionalProduct == null)
                  {
                    let productHtmldata = productStructureHtml(responseData.product, responseData.shades);
                    processPointsData(responseData.points);
                    jQuery(".shade_result_section").html(productHtmldata);
                    jQuery(".current_foundation_main_section").hide();
                    jQuery(".shade_result_section").show();
                  }
                  else
                  {
                    let productHtmldata =productStructurewithAdditionalHtml(responseData.product, responseData.additionalProduct, responseData.shades)
                    jQuery(".shade_result_section").html(productHtmldata);
                    jQuery(".current_foundation_main_section").hide();
                    jQuery(".shade_result_section").show();
                  }
                
              }
      })
  });


  jQuery(document).on("click",".ct-shadeFinder-submit-button",function(){
    //var skintoneArray = [];

      // jQuery(".ct-shadeFinder-active").each(function () {
      //     skintoneArray.push(jQuery(this).attr("data-id"));
      // });
      
      // Convert array to comma-separated string
//      var skintoneValue = skintoneArray.join(",");
      var skintoneValue = jQuery(".ct-shadeFinder-active.ct-shadeFinder-selected").attr("data-id")
        
        let repeatedValue = `${skintoneValue},${skintoneValue},${skintoneValue}`;
      let resultData={
          "shadeValue":repeatedValue,
          "method_call":"shadeImageQuizResult"
        }

       $.ajax({
                url: `${serverUrl}/shadeImageQuizResult?customerId=${cust_id}`,
                method: "POST",
                data:resultData,
                dataType: "json",
                success: function (responseData) {
                  if(responseData.additionalProduct == null)
                  {
                    let productHtmldata = productStructureHtml(responseData.product, responseData.shades);
                    processPointsData(responseData.points);
                    jQuery(".shade_result_section").html(productHtmldata);
                    jQuery(".ct-shadeFinder-img-inner").hide();
                    jQuery(".shade_result_section").show();
                  }
                  else
                  {
                    let productHtmldata =productStructurewithAdditionalHtml(responseData.product, responseData.additionalProduct, responseData.shades)
                    jQuery(".shade_result_section").html(productHtmldata);
                    jQuery(".ct-shadeFinder-img-inner").hide();
                    jQuery(".shade_result_section").show();
                  }
                }
        })
    
  })

  jQuery(document).on("click", ".ct_shade_sendemail", function () {
    let $emailData = jQuery("#emailData");
    let emailId = jQuery("#ct_input_shaemail").val();
    
    // Common attributes
    let shadeName = $emailData.attr("data-main-title");
    let productImage = $emailData.attr("data-main-img");
    let productUrl = $emailData.attr("data-main-url");

    // Initialize the object
    let emailSendData = {
        "customerName": "",
        "customerEmail": emailId,
        "shadeName": shadeName,
        "productUrl": productUrl,
        "productImage": productImage
    };

    // Add mini attributes if applicable
    if ($emailData.attr("data-type") === "mini") {
        emailSendData.shadeNameMini = $emailData.attr("data-mini-title");
        emailSendData.productImageMini = $emailData.attr("data-mini-img");
      emailSendData.productUrlMini = $emailData.attr("data-mini-url");
    }

    // Ensure `serverUrl` is defined before making the AJAX request
    if (typeof serverUrl !== "undefined" && serverUrl) {
        $.ajax({
            url: `${serverUrl}/mailsend`,
            method: "POST",
            data: emailSendData,
            dataType: "json",
            success: function (responseData) {
              if(responseData.message)
              {                
                jQuery(".ct-input-shade-email").val("");
                jQuery(".sucess_email").show();
              }
            },
            error: function (xhr, status, error) {
                console.error("Error sending email:", error);
            }
        });
    } else {
        console.error("serverUrl is not defined.");
    }
});


  
});

function productStructurewithAdditionalHtml(mainProd, addprod, shade){
   let matchConfidence = "Unknown"; // Default value
    let matchType = "N/A"; // Default type value
    let firstShadeKey = Object.keys(shade)[0]; // Get the first key in the shade object

    if (firstShadeKey && shade[firstShadeKey]) {
        let shadeData = shade[firstShadeKey];
        if (shadeData.match_weight) {
            matchConfidence = shadeData.match_weight;
        }

        // Extract the first type value from reasons_why array
        if (shadeData.reasons_why && shadeData.reasons_why.length > 0) {
            matchType = shadeData.reasons_why[0].type;
        }
    }
  let additionalWithProd=`
  <div class="current_foundation_heading"><h2 class="ct_heading">Here’s Your Shade</h2></div>
                        <span class="match-conf"><strong>MATCH CONFIDENCE : </strong>${matchType}</span>
                        <div class="plus-shade">
      <div class="info">
        <strong>The Shade Shifter lets you create your perfect match. </strong>
        <span>Mix with your recommended foundation shade for a seamless finish!</span>
      </div>
      <div class="shade_result-product">
          <div class="shade-img"><img src="${mainProd.variants[0].image}" loading="lazy" sizes="min(100vw, 1920px)" width="600"><h2 class="shade-title">Shade Name: ${mainProd.variants[0].options.find(option => option.name === "Shade").value}</h2>
                           </h2></div>
          <span class="shade-svg"><svg width="40" height="40" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3 34.2197H67" stroke="#775D6D" stroke-width="5" stroke-linecap="round"/> <path d="M35.011 3L34.2195 66.9951" stroke="#775D6D" stroke-width="5" stroke-linecap="round"/> </svg></span>
          <div class="shade-img"><img src="${addprod.variants[0].image}" loading="lazy" sizes="min(100vw, 1920px)" width="600"><h2 class="shade-title">Shade Name: ${addprod.variants[0].options.find(option => option.name === "Shade").value}</h2></div>
          <div class="shade-data">
            ${addToCartBtn(mainProd.variants[0].variant_id,mainProd.product_id, addprod.variants[0].variant_id)}
            
            <button id="ct_button_sendemail" type="button" class="ct_button shade-email">Email Your Shade To Yourself</button>
            <div class="ct-shade-datasend-main">
              <div class="ct-shade-datasend-inner">
                <p type="button" class="ct_button_datasend">Email Your Shade To Yourself</p>
                <input class="ct-input-shade-email" type="email" value="" id="ct_input_shaemail" placeholder="ENTER YOUR EMAIL">
                <span class="ct_shade_sendemail"></span>
                <span class="ct_shade-email-success sucess_email" style="display:none">Email has been sent!</span>
              </div>
              </div>
            </div>
        </div>
        <div id="emailData"  data-type="mini" data-main-img="${mainProd.variants[0].image}" data-main-title="${mainProd.variants[0].options.find(option => option.name === "Shade").value}" 
                    data-main-url="https://luarbeauty.in/products/${mainProd.handle}" data-mini-img="${addprod.variants[0].image}" data-mini-title="${addprod.variants[0].options.find(option => option.name === "Shade").value}" data-mini-url="https://luarbeauty.in/products/${addprod.handle}" style="display:none"></div>
    </div>`;
  return additionalWithProd;
}

function productStructureHtml(prod, shade) {
    // Extract match confidence dynamically (assuming taking the first shade entry)
    let matchConfidence = "Unknown"; // Default value
    let matchType = "N/A"; // Default type value
    let firstShadeKey = Object.keys(shade)[0]; // Get the first key in the shade object

    if (firstShadeKey && shade[firstShadeKey]) {
        let shadeData = shade[firstShadeKey];
        if (shadeData.match_weight) {
            matchConfidence = shadeData.match_weight;
        }

        // Extract the first type value from reasons_why array
        if (shadeData.reasons_why && shadeData.reasons_why.length > 0) {
            matchType = shadeData.reasons_why[0].type;
        }
    }

    let prodHtml = `<div class="current_foundation_heading"><h2 class="ct_heading">Here’s Your Shade</h2></div>
                        <span class="match-conf"><strong>MATCH CONFIDENCE : </strong>${matchType}</span>
                        <div class="shade_result-product">
                          <div class="shade-img"><img src="${prod.variants[0].image}" loading="lazy" sizes="min(100vw, 1920px)" width="600"></div>
                          <div class="shade-data">
                            <h2 class="shade-title">Shade Name: ${prod.variants[0].options.find(option => option.name === "Shade").value}</h2>
                            ${addToCartBtn(prod.variants[0].variant_id,prod.product_id)}
                            <button id="ct_button_sendemail" type="button" class="ct_button shade-email">Email Your Shade To Yourself</button>
                            <div class="ct-shade-datasend-main">
                              <div class="ct-shade-datasend-inner">
                                <p type="button" class="ct_button_datasend">Email Your Shade To Yourself</p>
                                <input class="ct-input-shade-email" type="email" value="" id="ct_input_shaemail" placeholder="ENTER YOUR EMAIL">
                                <span class="ct_shade_sendemail"></span>
                                <span class="ct_shade-email-success sucess_email" style="display:none">Email has been sent!</span>
                              </div>
                              </div>
                          </div>
                           <div id="emailData" data-main-img="${prod.variants[0].image}" data-main-title="${prod.variants[0].options.find(option => option.name === "Shade").value}" 
                    data-main-url="https://luarbeauty.in/products/${prod.handle}" data-type="main" style="display:none"></div>
                        </div>`;
    return prodHtml;
}

function addToCartBtn(varId,productId,varId2=""){
    let variantId = getLastId(varId);
    let variantId2 ="";
    if(varId2 != "")
    {
      variantId2 = getLastId(varId2);    
    }
    let prodId = getLastId(productId);

    let btn=`<div class="quick-add no-js-hidden">
                <product-form data-section-id="template--${prodId}__product-grid">
                <form method="post" action="/cart/add" id="quick-add-template--${prodId}__product-grid${prodId}"
                  accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate"
                  data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8"
                    value="✓">
                    ${variantId2 == ""?
                      `<input type="hidden" name="id" value="${variantId}">` 
                      :` <input type="hidden" name="items[0][id]" value="${variantId}">
                        <input type="hidden" name="items[0][quantity]" value="1">
            
                        <input type="hidden" name="items[1][id]" value="${variantId2}">
                        <input type="hidden" name="items[1][quantity]" value="1">
                        `}
            
                    <button id="quick-add-template--${prodId}__product-grid${prodId}-submit" type="submit" name="add"
                      class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog"
                      aria-labelledby="quick-add-template--${prodId}__product-grid${prodId}-submit title-template--${prodId}__product-grid-${prodId}"
                      aria-live="polite" data-sold-out-message="true">
                      <span>
                        Add to cart
                      </span>
                        <span class="sold-out-message hidden">
                        Sold out
                      </span>
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                        </svg>
                      </div>                    
                  </button><input type="hidden" name="product-id" value="${prodId}"><input type="hidden" name="section-id"
                    value="template--${prodId}__product-grid">
                </form>
              </product-form>
            </div>`;
    return btn;
  }

function getLastId(gid) {
    return gid.split("/").pop();
}